import { Component } from 'react';
import moment from 'moment';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import api from '../api/dataSource';
import { Loading } from '../components/Loading';
import CampeonatoResumen from '../components/CampeonatoResumen';
import classnames from 'classnames';

const MySwal = withReactContent(Swal)

class Campeonato extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titulo: 'Lista de campeonatos',
      esLista: true,
      campeonatos: [],
      currentCampeonato: 0
    };
    this.getFixture = this.getFixture.bind(this);
    this.verCampeonato = this.verCampeonato.bind(this);
    this.regresar = this.regresar.bind(this);
  }

  getFixture(){
  	MySwal.showLoading()
    MySwal.disableButtons()
    api.getCampeonato(`api/obtener_campeonatos_pagina`).then((resp) => {
    	this.setState({ campeonatos: resp })
    	MySwal.close()
    }).catch(error => {
      MySwal.close()
    })
  }

  regresar() {
    window.location.reload()
  }

  verCampeonato(x) {
    this.setState({
      titulo: x.nombre,
      currentCampeonato: x.id,
      esLista: false,
    })
  }

  componentDidMount(){
    this.getFixture()
  }

  render () {
    return (
      <div className="container" style={{paddingTop: '100px'}}>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody className="text-center mt-4">
                <CardTitle>
                  <h1>{this.state.titulo}</h1>
                </CardTitle>
              </CardBody>
            </Card>
          </div>
        </div>
        <br />  
        <div className="row">
          <div className="col-12">
            {
              this.state.esLista
              ? (
                <div className="row">
		            	<div className="col-md-12">
			              <div className="ec-fancy-title">
			                 <h2>Lista de campeonatos</h2>
			              </div>
			              <div className="ec-fixture-list ec-matches-list">
                			<ul style={{paddingInlineStart: '0'}}>
                				{
                					this.state.campeonatos.map((x, i) => (
                						<li key={x.id}>
		                          <div className={`ec-cell ${i % 2 === 0 ? 'celdax' : ''}`}>
		                          	Nombre: { x.nombre }
		                          </div>
		                          <div className={`ec-cell ${i % 2 === 0 ? 'celdax' : ''}`}>
		                          	Fecha creación { moment(x.created_at, 'YYYY-MM-DD').format('DD/MM/YYYY') }
		                          </div>
		                          <div style={{textAlign: 'center'}} className={`ec-cell ${i % 2 === 0 ? 'celdax' : ''}`}>
                                <Button onClick={() => this.verCampeonato(x)} color="secondary" size="sm">Ver</Button>
		                          </div>
			                      </li>
                					))
                				}
		                  </ul>
			              </div>
				          </div>
		            </div>
              )
              : (<CampeonatoResumen idCampeonato={this.state.currentCampeonato} />)
            }
          </div>
        </div>
        {
          !this.state.esLista
          && (
            <div className="row">
              <div className="col-12">
                <Card>
                  <CardBody className="text-center mt-4">
                    <CardTitle>
                      <Button onClick={() => this.regresar()} color="primary">Regresar Lista de Campeonatos</Button>
                    </CardTitle>
                  </CardBody>
                </Card>
                <br />
                <br />
                <br />
              </div>
            </div>
          )
        }
      </div>
    )
  }
}

export default Campeonato;
